import { render } from "./SubmitPhotoModal.vue?vue&type=template&id=24ae1f69&scoped=true"
import script from "./SubmitPhotoModal.vue?vue&type=script&lang=js"
export * from "./SubmitPhotoModal.vue?vue&type=script&lang=js"

import "./SubmitPhotoModal.vue?vue&type=style&index=0&id=24ae1f69&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24ae1f69"]])

export default __exports__